import React, { useState } from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Download, Users, CalendarDays, BarChart3 } from 'lucide-react';
import { exportAPI } from '../../services/api';
import { toast } from 'sonner';

const toIso = (date) => date.toISOString().split('T')[0];

const ExportCard = () => {
  const today = new Date();
  const ninetyDaysAgo = new Date(today.getTime() - 90 * 24 * 3600 * 1000);
  const [start, setStart] = useState(toIso(ninetyDaysAgo));
  const [end, setEnd] = useState(toIso(today));
  const [busy, setBusy] = useState(null);

  const run = async (key, action) => {
    setBusy(key);
    try {
      const filename = await action();
      toast.success(`Export téléchargé : ${filename}`);
    } catch (e) {
      toast.error("Erreur lors de l'export");
    } finally {
      setBusy(null);
    }
  };

  return (
    <Card className="bg-gradient-to-br from-purple-900/40 to-black border-2 border-purple-500/30 p-4 sm:p-6 space-y-5" data-testid="export-card">
      <div>
        <h3 className="text-lg font-bold text-purple-300 flex items-center gap-2">
          <Download className="h-5 w-5" /> Exports CSV
        </h3>
        <p className="text-sm text-gray-400 mt-1">Fichiers compatibles Excel / LibreOffice (séparateur « ; », encodage UTF-8).</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Button onClick={() => run('members', exportAPI.members)} disabled={busy !== null} data-testid="export-members-button"
          className="justify-start bg-purple-800/60 hover:bg-purple-700 text-white border border-purple-500/40">
          <Users className="mr-2 h-4 w-4" /> {busy === 'members' ? 'Export...' : 'Liste des membres'}
        </Button>
        <Button onClick={() => run('events', exportAPI.events)} disabled={busy !== null} data-testid="export-events-button"
          className="justify-start bg-purple-800/60 hover:bg-purple-700 text-white border border-purple-500/40">
          <CalendarDays className="mr-2 h-4 w-4" /> {busy === 'events' ? 'Export...' : 'Événements & participants'}
        </Button>
      </div>

      <div className="border-t border-purple-500/20 pt-4 space-y-3">
        <p className="text-sm font-semibold text-purple-200 flex items-center gap-2"><BarChart3 className="h-4 w-4" /> Fréquentation par jour</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
          <div className="space-y-1">
            <Label htmlFor="export-start" className="text-xs text-gray-400">Du</Label>
            <Input id="export-start" type="date" value={start} max={end} onChange={(e) => setStart(e.target.value)} data-testid="export-stats-start"
              className="bg-black/50 border-purple-500/30 text-white" />
          </div>
          <div className="space-y-1">
            <Label htmlFor="export-end" className="text-xs text-gray-400">Au</Label>
            <Input id="export-end" type="date" value={end} min={start} max={toIso(today)} onChange={(e) => setEnd(e.target.value)} data-testid="export-stats-end"
              className="bg-black/50 border-purple-500/30 text-white" />
          </div>
          <Button onClick={() => run('stats', () => exportAPI.stats(start, end))} disabled={busy !== null} data-testid="export-stats-button"
            className="bg-purple-600 hover:bg-purple-500 text-white">
            <Download className="mr-2 h-4 w-4" /> {busy === 'stats' ? 'Export...' : 'Exporter les statistiques'}
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default ExportCard;
